import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import circleInfoImage from '@ibk/shared-assets/icons/circle-info.svg';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { sharedUiTranslations } from '../../translations';
import styles from './NoAccountsError.module.css';
export function NoAccountsErrorBase() {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.container, "data-testid": 'no-accounts-error', children: [_jsx("img", { className: styles.icon, src: circleInfoImage, alt: 'Circle info', "data-testid": 'no-accounts-error-image' }), _jsx("span", { className: styles.title, "data-testid": 'no-accounts-error-title', children: t('no-accounts-error.title') }), _jsx("span", { className: styles.message, "data-testid": 'no-accounts-error-message', children: t('no-accounts-error.message') })] }));
}
export function NoAccountsError() {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(NoAccountsErrorBase, {}) }));
}
